import { PaginatedDataSheetBusinessEstimates } from '@lune-fe/dapi-models'
import { TableNew } from '@lune-fe/lune-ui-lib'
import { RefObject } from 'react'

import { DataSheetBusinessRow } from 'views/CalculateEmissions/index'

const DataSheetBusinessTable = ({
    paginatedEstimates,
    currentPage,
    pageHistoryRef,
    queryParams,
    loading,
}: {
    paginatedEstimates?: PaginatedDataSheetBusinessEstimates
    currentPage: number
    pageHistoryRef: RefObject<(string | undefined)[]>
    queryParams: string | undefined
    loading: boolean
}) => {
    return (
        <TableNew.TableContainer>
            <TableNew
                sx={{ minWidth: paginatedEstimates?.data.length ? '1200px' : 'auto' }}
                stickyHeader
                loading={!paginatedEstimates || loading}
                empty={!loading && !paginatedEstimates?.data.length}
                headerCells={
                    <>
                        <TableNew.TableCell colSize={4}>Calculation</TableNew.TableCell>
                        <TableNew.TableCell colSize={3}>Category</TableNew.TableCell>
                        <TableNew.TableCell colSize={2}>Client account</TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd>
                            Amount
                        </TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd>
                            tCO₂e
                        </TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd />
                    </>
                }
                bodyCells={
                    <>
                        {paginatedEstimates?.data.map((calculation, i: number) => (
                            <DataSheetBusinessRow
                                key={i}
                                calculation={calculation}
                                currentPage={currentPage}
                                pageHistoryRef={pageHistoryRef}
                                queryParams={queryParams}
                            />
                        ))}
                    </>
                }
            />
        </TableNew.TableContainer>
    )
}

export default DataSheetBusinessTable
